<app-modal-header>
  <div class="flex items-center">
    <svg-icon src="assets/icons/icon-files.svg" class="my-1 w-8 text-theme-500"></svg-icon>
    <div translate class="ml-2 text-lg font-semibold text-theme-500" translate>eclass.arquivo</div>
    <hr app-modal-divider />
    <div class="text-md font-semibold">{{ title }}</div>
  </div>
</app-modal-header>
<div app-modal-content class="h-[80vh]! w-[90vw]!">
  @if (video$ | async; as videoData) {
    <app-file-viewer class="h-full w-full" [data]="videoData"></app-file-viewer>
  } @else if (!!dataViewer) {
    <app-file-viewer class="h-full w-full" [data]="dataViewer"></app-file-viewer>
  } @else {
    <app-skeleton></app-skeleton>
  }
</div>
